import { render, staticRenderFns } from "./BottledWater.vue?vue&type=template&id=73a1bb2d"
import script from "./BottledWater.vue?vue&type=script&lang=js"
export * from "./BottledWater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports